import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import {
    Button, Form, Input, Select,
} from 'antd';
import { getLeadsStatusRequest } from '../../redux/actions/get_leads_status.actions';
import { changeLeadsStatusRequest } from '../../redux/actions/change_lead_status.actions';

const mapStateToProps = (state) => {
    const {
        root_id, status, current_status, lead_profile,
    } = state.Leads.Lead_profile.Lead_general;
    return {
        root_id, status, current_status, lead_profile,
    };
}; const FormItem = Form.Item; const
    { Option } = Select;

export default connect(mapStateToProps, null)(class CustomerRejectionModal extends PureComponent {
  state = {
      selectedValue: this.props.current_status.name,
      description: '',
  };

  componentDidMount() {
      this.props.dispatch(getLeadsStatusRequest());
  }

  handleChangeSelect = value => this.setState({ selectedValue: value });

  changeStatus = () => {
      if (this.state.selectedValue.length > 0) {
          this.props.dispatch(changeLeadsStatusRequest(this.props.root_id, this.state.selectedValue));
          if (this.state.description.length > 0) {
              this.setState({ description: '' });
          }
          this.props.closeModal();
      }
  };

  handleChangeTextArea = event => this.setState({ description: event.target.value });

  render() {
      return (
          <Form>
              <FormItem label="Please choose the reason why the customer is rejecting our offer">
                  <Select
                      showSearch
                      placeholder="Select Reject Reason"
                      notFoundContent="Reject reason not Found"
                      value={this.state.selectedValue}
                      onChange={this.handleChangeSelect}
                  >
                      <Option value="" style={{ color: 'lightgray' }} disabled>Select Reject Reason</Option>
                      <Option value="5beac062f25bf5f49685abff">Customer Cancelled - Already Sold Bike</Option>
                      <Option value="5beac062f25bf5f49685ac00">Customer Cancelled - Offered Better Price Elsewhere</Option>
                      <Option value="5beac063f25bf5f49685ac01">Customer Wants Too Much</Option>
                      <Option value="5beac063f25bf5f49685ac02">Customer Changed Mind</Option>
                      <Option value="5beac063f25bf5f49685ac03">Tried To Call - No Answer</Option>
                      <Option value="5beac063f25bf5f49685ac04">Tried To Call - Wrong Number</Option>
                  </Select>
              </FormItem>
              <FormItem label="Add Note">
                  <Input.TextArea placeholder="Enter Description" value={this.state.description} onChange={this.handleChangeTextArea} />
              </FormItem>
              <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                  <Button onClick={this.props.closeModal}>Cancel</Button>
                  <Button type="primary" style={{ marginLeft: 10 }} icon="edit" onClick={this.changeStatus}>Change Status</Button>
              </div>
          </Form>
      );
  }
});



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/components/Modals/CustomerRejectedModal.js